module.exports = new __parcel__URL__("epa-ch4emission-yeargrid-v2express.thumbnails.total.other.annual.0ae99e5d.png").toString();